$(function () {
  enableVideoModalToggle(".js-video-toggle", ".js-video-parent", ".js-video");
  enableSearchToggle(".js-search-toggle", ".js-search");
  enableMenuScroller(".js-header", ".js-top-header", ".js-search");
  enableTabs(".js-tab-toggle", ".js-tab");
  enableShopFilters(".js-filter", ".js-filter-parent", ".js-filters");
  enableShopSorters(".js-sorter", ".js-filters");
  enableShopLayout(".js-layout-toggle", ".js-layout", ".js-filters");
  enableBurgerToggle(".js-burger-toggle", ".js-menu", ".js-page");
  enableMobileShopFiltersToggle(".js-mobile-filters-toggle", ".js-filters");
  enableSmoothScroll();
  enablePriceMatcher(
    ".js-price",
    ".single_variation .price .amount",
    "#pa_product-sizes"
  );
  enableModalPriceMatcher(".js-modal-price", ".js-modal-parent");
  enableShopProductSwiper(".js-product-swiper");
  enableDistributorFormFields();
  enableCookieOkay(".js-cookie-accept", ".js-cookies");

  $(".variations_form").on("show_variation", function (event, v) {
    //console.log('vv', v);
    if (v.image.full_src) {
      $(".js-variation-image").attr("src", v.image.full_src);
      $(".js-variation-image").fadeIn(300);
    }

    $(".js-price").html("£" + v.display_price);
  });

  if ($("[data-size]").length) {
    $("[data-size]").hide();
    $('[data-size="' + $("#pa_product-sizes").val() + '"]:first-child').show();

    $("#pa_product-sizes").on("input", function (event) {
      $("[data-size]").hide();

      var value = $(this).val();
      //console.log(value);

      if ($('[data-size="' + value + '"]').length > 1) {
        $('[data-size="' + value + '"]:first-child').show();
      } else {
        $('[data-size="' + value + '"]').show();
      }
    });
  }
  // Banc restrict variation by country
  if ($(".user_countryCode").length) {
    $(window).on("load", function () {
      $("#pa_product-sizes").change();
    });
    $("#pa_product-sizes").on("change", function () {
      var element = $(this).find("option:selected");
      var authType = element.attr("type");
      var authCode = element.attr("restrict");
      var userCode = $(".user_countryCode").val();

      if (authType == "deny") {
        if (
          authCode.toLowerCase().includes(userCode.toLowerCase()) ||
          authCode == "0"
        ) {
          $(".single_add_to_cart_button").prop("disabled", true);
          $(".restrictCountry").text(
            "this product is not available in the following country codes: " +
              authCode
          );
        } else {
          $(".single_add_to_cart_button").prop("disabled", false);
          $(".restrictCountry").text("");
        }
      }
      if (authType == "allow") {
        if (
          authCode.toLowerCase().includes(userCode.toLowerCase()) ||
          authCode == "0"
        ) {
          $(".single_add_to_cart_button").prop("disabled", false);
          $(".restrictCountry").text("");
        } else {
          $(".single_add_to_cart_button").prop("disabled", true);
          $(".restrictCountry").text(
            "this product is restricted to " + authCode + " only"
          );
        }
      }
    });
  }

  //
  var params = new URLSearchParams(window.location.search);

  if (params.has("form")) {
    var form = params.get("form");

    $('[data-target="#' + form + '"]').click();
  } else {
    $('[data-target="#general-enquiry"]').click();
  }
});

function enableCookieOkay(toggle, parent) {
  if (document.cookie.indexOf("cookie-policy") < 0) {
    jQuery(parent).css("display", "block");

    jQuery(toggle).on("click", function () {
      var expires = "";
      var date = new Date();
      date.setTime(date.getTime() + 10000 * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toUTCString();
      document.cookie = "cookie-policy" + "=" + 1 + expires + "; path=/";

      jQuery(parent).slideUp(250);
    });
  }
}

function enableDistributorFormFields() {
  if ($(".your-product-name").length) {
    $(".your-product-name").find("input").val(document.title);
    $(".your-product-url").find("input").val(window.location.href);
  }
}

function enableShopProductSwiper(target) {
  if ($(target).length) {
    var swiper = new Swiper(target, {
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
  }
}

function enableModalPriceMatcher(target, parent) {
  var parent = $(parent);

  setTimeout(function () {
    $(parent).on("show.bs.modal", function (event) {
      var item = $(event.currentTarget);

      var priceTarget = item.find(".single_variation .price .amount");

      if (priceTarget.length) {
        var price = priceTarget.text();
      } else {
        var price = item.find(".price .amount").text();
      }

      $(item).find(target).text(price);
    });

    $(parent).each(function (index, item) {
      var parent = $(item);

      $("#pa_product-sizes", parent).on("change", function () {
        setTimeout(function () {
          var priceTarget = parent.find(".single_variation .price .amount");

          if (priceTarget.length) {
            var price = priceTarget.text();
          } else {
            var price = parent.find(".price .amount").text();
          }

          parent.find(target).text(price);
        }, 250);
      });
    });
  }, 250);
}

function enablePriceMatcher(target, from, watcher) {
  setTimeout(function () {
    if ($(from).length) {
      $(target).html($(from).text());
    } else {
      $(target).html($(".price").text());
    }
  }, 250);

  $(watcher).on("change", function () {
    setTimeout(function () {
      if ($(from).length) {
        $(target).html($(from).text());
      } else {
        $(target).html($(".price").text());
      }
    }, 250);
  });
}

function enableMobileShopFiltersToggle(toggle, filters) {
  $(toggle).on("click", function () {
    $(toggle).toggleClass("shop__mobile-filters-toggle--open");
    $(filters).toggle();
  });
}

function enableBurgerToggle(toggle, menu, page) {
  $(toggle).on("click", function () {
    $(menu).toggleClass("navigation--mobile-active");

    $(page).toggleClass("page--fixed");
  });
}

function enableShopLayout(toggle, layout, form) {
  var params = new URLSearchParams(window.location.search);

  var currentLayout = params.get("layout");

  if (currentLayout) {
    $(layout).hide();

    $(".shop__layout-item--active").removeClass("shop__layout-item--active");

    $("#" + currentLayout).show();

    $('[data-layout="#' + currentLayout + '"]').addClass(
      "shop__layout-item--active"
    );
  }

  $(toggle).on("click", function () {
    // $(layout).fadeOut(150);

    // // $('.shop__layout-item--active').removeClass('shop__layout-item--active');

    // // $($(this).attr('data-layout')).fadeIn(200);
    // // $(this).addClass('shop__layout-item--active');

    params.set("layout", $(this).attr("data-layout").replace("#", ""));

    window.location.href = "?" + params.toString();
  });
}

function enableShopSorters(toggle, form) {
  var params = new URLSearchParams(window.location.search);

  $(form).attr("action", "/products?" + params.toString());

  $(toggle).on("change", function () {
    var value = $(this).val();
    var split = value.split("=");

    params.set(
      "layout",
      $(".shop__layout-item--active").attr("data-layout").replace("#", "")
    );

    params.set(split[0], split[1]);

    $(form).attr("action", "/products?" + params.toString());

    $(form).submit();
  });
}

function enableSmoothScroll() {
  $('a[href^="#"]').each(function (index, item) {
    $(item).on("click", function (event) {
      event.preventDefault();

      if ($(this).attr("data-product")) {
        var href = $(this).attr("href");

        if (href === "#find-a-distributor") {
          $('[data-tab-target="#distributor"]').click();
        } else {
          $('[data-tab-target="#direct"]').click();
        }

        document.querySelector("#find-a-distributor").scrollIntoView({
          behavior: "smooth",
        });
      } else {
        document.querySelector($(this).attr("href")).scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  });
}

function enableShopFilters(toggle, parent, form) {
  var params = new URLSearchParams(window.location.search);

  if (params.has("filters")) {
    var filters = params.get("filters").split(" ");
  } else {
    var filters = [];
  }

  $(toggle).on("click", function () {
    var parent = $(this).parent(parent);
    var input = $("input", parent);

    $(input).click();

    if (filters.indexOf($(input).val()) !== -1) {
      var index = filters.indexOf($(input).val());

      filters.splice(index, 1);
    } else {
      filters.push($(input).val());
    }

    if (filters.length) {
      params.set("filters", filters.join("+"));
    } else {
      params.delete("filters");
    }

    window.location.href = decodeURIComponent(
      "/products/?" + params.toString()
    );
  });
}

function enableTabs(toggle, tab) {
  var toggle = $(toggle);

  toggle.on("click", function () {
    $(".tabs__heading--active").removeClass("tabs__heading--active");

    $(this).addClass("tabs__heading--active");

    var target = $(this).attr("data-tab-target");

    $(".tabs__tab--active").removeClass("tabs__tab--active");
    $(".tabs__tab" + target).addClass("tabs__tab--active");
  });

  if (window.location.href.indexOf("#find-a") !== -1) {
    $('[data-tab-target="#distributor"]').click();
  }
}

function enableVideoModalToggle(toggle, parent, video) {
  var toggle = $(toggle);

  toggle.on("click", function () {
    $($(this).closest(parent).find(video)).modal("toggle");
  });
}

function enableSearchToggle(toggle, search) {
  var toggle = $(toggle);

  toggle.on("click", function () {
    if ($("#wpadminbar").length) {
      $(search).toggleClass("search--visible-admin");

      if ($(search).hasClass("search--visible-admin")) {
        $("input", search).focus();
      }
    } else {
      $(search).toggleClass("search--visible");

      if ($(search).hasClass("search--visible")) {
        $("input", search).focus();
      }
    }
  });
}

function enableMenuScroller(header, topHeader, search) {
  var lastScrollTop = 0;
  var topWrapperHeight = $(topHeader).height();

  var positionStickySupport = (function () {
    var el = document.createElement("a"),
      mStyle = el.style;
    mStyle.cssText =
      "position:sticky;position:-webkit-sticky;position:-ms-sticky;";
    return mStyle.position.indexOf("sticky") !== -1;
  })();

  if (!positionStickySupport) {
    $(".js-search").addClass("not-supported-sticky");

    return;
  }

  $(window).on("wheel mousewheel DOMMouseScroll", function (event) {
    var amount = $(this).scrollTop();

    if (amount > lastScrollTop) {
      // down
      if (amount > topWrapperHeight) {
        $(header).addClass("header--small");
        $(search).addClass("search--header-small");
      }
    } else {
      // up
      if (lastScrollTop - amount > topWrapperHeight - 10) {
        $(header).removeClass("header--small");
        $(search).removeClass("search--header-small");
      }
    }

    lastScrollTop = amount;
  });

  $(window).on("load resize", function () {
    if (this.matchMedia("(min-width: 992px)").matches) {
      $(".navigation--mobile").removeClass("navigation--mobile-active");
    }
    // suppress page scroll when mobile nav opened
    // $(".mobile-toggle-cta").click(function (e) {
    //   var menuItem = $(this);
    //   if (menuItem.attr("aria-expanded") === "true") {
    //     $("body").css("overflow", "hidden");
    //   } else if (menuItem.attr("aria-expanded") === "false") {
    //     $("body").css("overflow", "auto");
    //   }
    // });
  });

  $(".navigation--mobile .navigation__item.dropdown").on("click", function (e) {
    e.preventDefault();
    if ($(this).find(".dropdown-menu").css("display") == "none") {
      $(this).find(".dropdown-menu").css("display", "block");
    } else {
      $(this).find(".dropdown-menu").css("display", "none");
    }
  });
  $(".navigation--mobile .navigation__item.dropdown-item").on(
    "click",
    function (e) {
      $(".navigation--mobile").removeClass("navigation--mobile-active");
      location.href = $(this).attr("href");
    }
  );
}
